<template>
  <div class="cargo-van slide">
    <VerticalAnimation :animation="animation" :background="background" />
    <div class="vertical-layout animated fadeIn delay-2s">
      <p class="store">STORE 0111</p>
      <h1>Cargo Van</h1>
      <p>Back at store 0111, John Deerling is recognized in a known theft (KT) incident. CCTV footage shows Deerling getting into a white cargo van. The make, model, and partial tags have been tied to other KTs in the area.</p>
    </div>
    <router-link to="/gps-surveillance">
      <NextButton />
    </router-link>
  </div>
</template>

<script>
import VerticalAnimation from '@/components/VerticalAnimation.vue'
import NextButton from '@/components/NextButton.vue'
import CargoVan from '@/assets/cargo-van.js'
import VerticalImage from '@/assets/orangeV.png'

export default {
  name: 'cargo-van',
  components: {
    VerticalAnimation,
    NextButton
  },
  data() {
    return {
      animation: CargoVan,
      background: VerticalImage
    }
  },
  mounted() {
    window.setTimeout(() => {
          window.scrollTo(0,1)
        }, 1000)
  }
}
</script>

<style lang="scss" scoped>
  .vertical-layout {
    top: 30%;
    width: 80%
  }
  h1 {
    margin-bottom: 0;
  }
  p {
    margin-top:5px;
  }
</style>
